import { Controller } from 'stimulus'
import { useDispatch } from 'stimulus-use'

export default class extends Controller {
  static targets = ['content', 'input']

  initialize() {
    useDispatch(this)
  }

  connect() {
    this._contentMapped = this.initializedContentsMapping()
    Promise.resolve().then(() => { this.afterConnect() })
  }

  afterConnect() {
    this.updateContents()
  }

  initializedContentsMapping() {
    const contentsMapped = {}
    this.contentTargets.forEach((content) => {
      const id = content.getAttribute(`data-${this.identifier}-content-id`)

      contentsMapped[id] = content
    })
    return { ...contentsMapped }
  }

  updateContents() {
    this.inputTargets.forEach((input) => {
      const id = input.getAttribute(`data-${this.identifier}-content-ref-id-param`)
      const shouldDisplay = input.checked
      const contentToToggle = this._contentMapped[id]
      this.disableInputsIn(contentToToggle, !shouldDisplay)
      this.display(contentToToggle, shouldDisplay)
    })
    this.dispatch('radioContentHiddenUpdatedContents')
  }

  disableInputsIn(domElem, shouldDisable) {
    if (domElem) {
      let toggleDisable

      if (shouldDisable) {
        toggleDisable = (input) => { input.setAttribute('disabled', 'disabled') }
      } else {
        toggleDisable = (input) => { input.removeAttribute('disabled', 'disabled') }
      }

      const inputs = domElem.querySelectorAll('input')
      inputs.forEach((input) => {
        toggleDisable(input)
      })
    }
  }

  display(domElem, shouldDisplay) {
    if (domElem) {
      if (shouldDisplay) {
        domElem.removeAttribute('hidden')
      } else {
        domElem.setAttribute('hidden', 'hidden')
      }
    }
  }
}
